/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Signpost = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 3v3" }],
    ["path", { d: "M18.5 13h-13L2 9.5 5.5 6h13L22 9.5Z" }],
    ["path", { d: "M12 13v8" }]
  ]
];

export { Signpost as default };
//# sourceMappingURL=signpost.js.map
